import T from 'i18n-react'

import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
} from 'redux-saga/effects'

import {
  get,
  post
} from 'helpers/RequestUtil'

import {
  FETCH_CPM_DETAILS,
  FETCH_CPM_DETAILS_SELECTION,
  POST_CPM_DETAILS
} from './constants'

import {
  fetchCpmDetails as fetchCpmDetailsAction,
  fetchCpmDetailsStart,
  fetchCpmDetailsSuccess,
  fetchCpmDetailsError,
  fetchCpmDetailsSelectionStart,
  fetchCpmDetailsSelectionSuccess,
  fetchCpmDetailsSelectionError,
  postCpmDetailsStart,
  postCpmDetailsSuccess,
  postCpmDetailsError,
  updateCpmDetailsChange
} from './actions'

import {
  cpmDetailsSelector
} from './selectors'

import {
  overwriteTables,
  updateTables
} from 'containers/Entity/actions'

import {
  error as errorAction
} from 'containers/App/Notification/actions'

function getEntityData(data){
  if(data.entities.project_cpm_detail_views && Object.values(data.entities.project_cpm_detail_views)[0]){
    return Object.values(data.entities.project_cpm_detail_views)[0]
  } else {
    return {}
  }
}

function* fetchCpmDetails(action) {
  const { projectId } = action
  try {
    yield put(fetchCpmDetailsStart())
    const data = yield call(
      get,
      `/api/fulcrum/projects/${projectId}/cpm_detail`
    )

    // Add new data to entities and results
    yield put(overwriteTables(data))
    // Put new NVQual Details object into NVQualDetailsChange (these are the values that change when the form is edited)
    yield put(updateCpmDetailsChange(getEntityData(data)))
    yield put(fetchCpmDetailsSuccess())
  } catch(error) {
    yield put(errorAction(T.translate('project.cpmDetails.fetchError')))
    yield put(fetchCpmDetailsError(error))
  }
}

function* watchFetchCpmDetails(){
    yield takeEvery(FETCH_CPM_DETAILS, fetchCpmDetails)
}

function* fetchCpmDetailsSelection(action) {
  try {
    yield put(fetchCpmDetailsSelectionStart())
    const data = yield call(
      get,
      '/api/fulcrum/cpm_details_selection'
    )
    yield put(updateTables(data))
    yield put(fetchCpmDetailsSelectionSuccess())
  } catch(error) {
    yield put(errorAction(T.translate('project.cpmDetails.fetchSelectionError')))
    yield put(fetchCpmDetailsSelectionError(error))
  }
}

function* watchFetchCpmDetailsSelection(){
  yield takeEvery(FETCH_CPM_DETAILS_SELECTION, fetchCpmDetailsSelection)
}

function* postCpmDetails(action){
  try{
    const { projectId, params } = action
    yield put(postCpmDetailsStart())
    yield call(
      post,
      'project_cpm_details',
      params,
      `/api/fulcrum/projects/${projectId}/cpm_detail`
    )
    yield put(postCpmDetailsSuccess())
    // Refetch Cpm Details for selected project
    yield put(fetchCpmDetailsAction(projectId))
  } catch(error) {
    yield put(errorAction(T.translate('project.cpmDetails.postError')))
    yield put(postCpmDetailsError(error))
    // Replace the changed values with the unchanged ones again
    const detailObject = yield select(cpmDetailsSelector)
    yield put(updateCpmDetailsChange(detailObject))
  }
}

function* watchPostCpmDetails(){
  yield takeEvery(POST_CPM_DETAILS, postCpmDetails)
}

function* loadSagas() {
  yield all([
    fork(watchFetchCpmDetails),
    fork(watchFetchCpmDetailsSelection),
    fork(watchPostCpmDetails)
  ])
}

export default loadSagas
